/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { Logger } from '@app/core';
import { CitiesService } from '@app/settings/cities/cities.service';
import { CitiesFormService } from '@app/settings/cities/cities-form.service';
import { City } from '@app/settings/cities/cities.model';
import { ActivatedRoute } from '@angular/router';
import { Country } from '@app/settings/countries/countries.model';
import { CountriesService } from '@app/settings/countries/countries.service';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { CitiesSeoFormService } from '@app/settings/cities/cities-seo-form.service';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';

const log = new Logger('citiesListComponent');

@Component({
  selector: 'app-cities-list',
  templateUrl: './cities-list.component.html',
  styleUrls: ['./cities-list.component.scss'],
})
export class CitiesListComponent extends KendoGridComponent implements OnInit {
  citiesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  countryId: number;
  country: Country;
  laravelModels = LaravelModelsEnum;
  env = environment;
  UserRoleType = UserRoleType;
  MediaLibraryAcceptTypes = MediaLibraryAcceptTypes;
  LaravelModels = LaravelModelsEnum;
  constructor(
    private cityService: CitiesService,
    private countryService: CountriesService,
    private citiesFormService: CitiesFormService,
    private route: ActivatedRoute,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService,
    private citiesSeoFormService: CitiesSeoFormService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.loadData();
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    log.debug('loadData');
    this.route.params.subscribe((params) => {
      this.countryId = +params['id']; // (+) converts string 'id' to a number
    });

    this.state = state;
    this.apiQuery.setDataSetFilters(state).addFilter('country_id', this.countryId);

    this.cityService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.citiesResponse = response;
      this.data = response.getGridData();
    });
    this.countryService.show(this.countryId).subscribe((response: Country) => {
      this.country = response;
    });
  }

  add() {
    this.citiesFormService.open(null, this.country).then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param city City object
   * @param country
   */
  edit(city: City, country: Country = null) {
    this.citiesFormService.open(city, country).then(() => {
      this.loadData();
    });
  }

  /**
   *
   * @param city City object
   */
  delete(city: City) {
    this.cityService.destroy(city.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  editSeo(city: City): void {
    this.citiesSeoFormService.open(city);
  }
}
